import { Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction, when } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import AnotacaoService from '../../service/AnotacaoService';
import ReactComponent from '../ReactComponent';
import TextFieldSecretaria from '../TextFieldSecretaria';

class AnotacaoCurtaSecretario extends ReactComponent {
    variant = 'outlined';
    timeoutSalvar;
    refCampo;
    anotacaoService = new AnotacaoService();

    constructor(props) {
        super(props);

        makeObservable(this, {
            variant: observable,
            colocarFocoCampo: action,
            registro: computed,
            componenteExibicao: computed,
            identificadorCampo: computed,
            informacaoProcessoSalaSessao: computed,
            anotacao: computed,
            handleChangeAnotacao: action,
            mudarVariant: action,
            onFocusVariant: action,
            onLoseFocusVariant: action
        });

        this.refCampo = React.createRef();
    }

    componentDidMount() {
        this.mudarVariant();
        this.colocarFocoCampo();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        this.colocarFocoCampo();
    }

    colocarFocoCampo() {
        if (
            this.sessaoStore.campoFocoPosOrdenacao === this.identificadorCampo &&
            this.sessaoStore.numeroProcessoFocoPosOrdenacao === this.registro.numeroProcesso
        ) {
            setTimeout(() => {
                if (!this.registro.rendered) {
                    runInAction(() => {
                        this.store.processoScroll = this.registro;
                    });
                }

                when(
                    () => {
                        return this.refCampo.current;
                    },
                    () => {
                        return this.refCampo.current.focus();
                    }
                );
            }, 1);
        }
    }

    get registro() {
        return this.observableProps.registro;
    }

    get componenteExibicao() {
        return this.observableProps.componenteExibicao ? this.observableProps.componenteExibicao : '';
    }

    get identificadorCampo() {
        return `AnotacaoCurtaSecretario-${this.componenteExibicao}`;
    }

    get informacaoProcessoSalaSessao() {
        return this.registro.informacaoProcessoSalaSessao;
    }

    get anotacao() {
        return this.informacaoProcessoSalaSessao.anotacao ? this.informacaoProcessoSalaSessao.anotacao : '';
    }

    handleChangeAnotacao = (value) => {
        this.informacaoProcessoSalaSessao.anotacao = value;
    };

    mudarVariant = () => {
        this.variant = this.anotacao && this.anotacao.length > 0 ? 'filled' : 'outlined';
    };

    onFocusVariant = () => {
        this.sessaoStore.numeroProcessoFocoPosOrdenacao = this.registro.numeroProcesso;
        this.sessaoStore.campoFocoPosOrdenacao = this.identificadorCampo;
        this.variant = 'outlined';
    };

    onLoseFocusVariant = () => {
        if (this.sessaoStore.numeroProcessoFocoPosOrdenacao === this.registro.numeroProcesso) {
            this.sessaoStore.numeroProcessoFocoPosOrdenacao = undefined;
            this.sessaoStore.campoFocoPosOrdenacao = undefined;
        }
        this.mudarVariant();
    };

    salvarAnotacao = (anotacao) => {
        this.salaSessaoStore.salvarAnotacao(this.registro, anotacao).then(() => {
            this.salaSessaoStore.ordenarProcessos();
        });
    };

    render() {
        return (
            <Tooltip
                title={
                    <Typography
                        display="inline"
                        fontSize="14px"
                        fontWeight="bold"
                        color="inherit"
                    >
                        Anotação curta
                    </Typography>
                }
            >
                <div>
                    <TextFieldSecretaria
                        margin="none"
                        id={'idAnotacao' + this.registro.numeroProcesso}
                        disabled={this.registro.necessitaImportacaoSalaSessao}
                        multiline={false}
                        value={this.anotacao}
                        onChange={this.handleChangeAnotacao}
                        salvar={this.salvarAnotacao}
                        tempoTimeout={2000}
                        variant={this.variant}
                        inputProps={{
                            maxLength: 10,
                            style: {
                                height: '28px',
                                lineHeight: '28px',
                                fontSize: '14px',
                                width: '10ch',
                                padding: '0px 7px 0px 7px'
                            }
                        }}
                        InputPropsStyle={{ padding: '0' }}
                        onFocus={this.onFocusVariant}
                        onLoseFocus={this.onLoseFocusVariant}
                        inputRef={this.refCampo}
                    />
                </div>
            </Tooltip>
        );
    }
}

export default inject('stores')(observer(AnotacaoCurtaSecretario));
